module.exports = __webpack_public_path__ + "static/media/revision-large@3x.0943b5fd.png";